import { render, staticRenderFns } from "./ICard.vue?vue&type=template&id=05f27888&"
import script from "./ICard.vue?vue&type=script&lang=js&"
export * from "./ICard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports